<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .compose-type1 .neirong{
    display: block!important;
  }
  .effect-lists1{
    flex-wrap: wrap;
    justify-content: flex-start!important;
  }
  .required{
    margin-top: 5px!important;
  }
  .compose-type1{
    padding-bottom: 20px!important;
  }
}
@media screen and (min-width: 641px){
  .effect-lists{
    //display: block!important;
    justify-content: space-between!important;
    flex-wrap:wrap;
    overflow: auto;
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}

.effect-lists li{
  width: 21% !important;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/T载体克隆/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.cons{
  display: none;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/产品及服务/T载体克隆/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/T载体克隆banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="font-weight:bold;color: #014492;margin-bottom: 10px;">T载体克隆</p>
        <p class="desc" style="margin-bottom: 10px;">T载体（T-Vector）是一种用于PCR产物的克隆和转运（TA克隆）的专用质粒载体，是线性载体，无需酶切，可直接与具有A末端的PCR产物连接，可提高PCR产物克隆的效率。T载体克隆属于非定向克隆。</p>
        <p class="desc" style="font-weight:bold;margin-bottom: 10px;">T载体的作用原理</p>
        <p class="desc" style="margin-bottom: 10px;">大部分耐热性DNA聚合酶进行PCR反应时都具有在PCR产物的3末端添加一个“A”的特性。具有线性化特点的T载体的每条链的3’端都带有一个突出的T，可与PCR克隆产物的A末端互补配对，快速、精准、高效地提高了PCR产物连接和克隆的效率。</p>
      </div>
      <div class="container">
        <div class="c-title">服务流程<small>Service process</small></div>
        <img src="@/assets/img/产品及服务/T载体克隆/服务流程.png" class="img-fluid">
        <!-- <img src="@/assets/img/产品及服务/T载体克隆/服务流程.png" class="img-fluid cons"> -->
      </div>
      <div class="container" style="margin-bottom: 50px;">
        <div class="c-title">擎科交付<small>Tsingke delivery</small></div>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">1.测序峰图及比对结果；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">2.提供菌液及质粒返还；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">3.T 载体克隆报告单一份。</p>
      </div>

      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/T载体克隆/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.可以连接微量 DNA;</p>
                <p class="mb20">2.可连接平末端、粘性末端载体;</p>
                <p class="mb20">3.99 % 克隆均为阳性克隆，基本无空载体;</p>
                <p class="mb20">4.0.1 k~5 k 片段均可进行克隆。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists effect-lists1">
            <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
              <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'DNA提取', img: '1', ref: '/tec/DNA_extraction'},
        {name: 'PCR扩增', img: '2', ref: '/tec/PCR'},
        {name: 'SSR/STR检测', img: '4', ref: '/tec/SSR'},
        {name: 'SNP检测', img: '5', ref: '/tec/SNP'},
        {name: '特定基因检测', img: '6', ref: '/tec/specific'},
        {name: '荧光定量PCR', img: '7', ref: '/tec/qPCR'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
        {name: '细胞系鉴定', img: '9', ref: '/tec/identification'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Tvector_cloning.vue